// Talking Cards — light interactions
// Currently a no-op; placeholder for future enhancements (cart drawer, etc.)
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
